/** Lip-sync UI toasts: client validation → message toast; API errors → notification toast. */
import { pushAppToast } from '~/utils/appToastStore'

export const LIP_UI_TOAST_CLASS = 'lip-ui-toast'

const DEFAULT_TITLES = {
  success: 'Success',
  warning: 'Warning',
  error: 'Error',
  info: 'Info',
}

/** Frontend validation, limits, and local action feedback. */
export function notifyClient(type, message) {
  pushAppToast({ type, message, variant: 'message' })
}

/** Backend API failures and upload / task errors (shows title + message). */
export function notifyServer(type, message, title) {
  const resolvedTitle = title ?? DEFAULT_TITLES[type] ?? DEFAULT_TITLES.info
  pushAppToast({
    type,
    message,
    title: resolvedTitle,
    variant: 'notification',
  })
}
